<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="content video-monitor">
        <div class="leftNav" v-if="!isShowAll">
          <div class="leftSpot"></div>
          <div class="leftNav_title">
            实时视频
            <div class="title_btmLine"></div>
          </div>
          <el-input
            placeholder="搜索监控点"
            class="nav-tree-filter"
            v-model="filterText"
          ></el-input>
          <div class="nav-tree-content">
            <el-tree
              style="height: 100%"
              v-loading="loading"
              :element-loading-text="loadingText"
              @node-click="nodeClick"
              :data="nodes"
              node-key="id"
              :props="defaultProps"
              :filter-node-method="filterNode"
              class="zj-demo-player-tree-device-tree"
              ref="tree"
            ></el-tree>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="rightContent">
          <div class="topContent">
            <div class="oneVideoBox">
              <div class="showOneVideo">
                <div style="width: 100%; height: 100%">
                  <div style="width: 100%; height: 100%" id="setting">
                    <HikCameraVideo
                      @clickOk="handleVerifyDialogOk"
                      @clickCancel="handleVerifyDialogCancel"
                      :setting="setting"
                      :sysParams="sysParams"
                      :cameraInfos="CameraInfos"
                      :cameraIndexCode="cameras[0].cameraId"
                    ></HikCameraVideo>
                  </div>
                </div>
              </div>
              <div class="controlOneVideo" v-if="!isShowAll">
                <div class="leftSpot"></div>
                <div class="circleBox">
                  <div id="wrap">
                    <div
                      class="sector"
                      :style="{
                        transform: `rotate(${45 * index - 22.5 + 45}deg)`,
                      }"
                      v-for="(item, index) in color"
                      :key="index"
                    >
                      <div
                        class="inner"
                        :id="`innder${index + 1}`"
                        @mousedown="chooseTriangle(index + 1)"
                        @mouseup="mouseupButton(index + 1)"
                      ></div>
                    </div>
                    <div
                      class="sector"
                      :style="{ transform: `rotate(292.5deg)` }"
                    >
                      <div
                        class="inner"
                        :id="`innder7`"
                        @mousedown="chooseTriangle(7)"
                        @mouseup="mouseupButton(7)"
                        style="z-index: 9999"
                      ></div>
                      <div
                        class="innerf"
                        :id="`innder0`"
                        @mousedown="chooseTriangle(0)"
                        @mouseup="mouseupButton(0)"
                      ></div>
                    </div>
                    <div class="circleMini">
                      <div
                        class="fangstart"
                        @click="startOneVideo()"
                        v-if="!isStart"
                      ></div>
                      <div
                        class="fangstop"
                        @click="stopOneVideo()"
                        v-if="isStart"
                      ></div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 4rem; padding: 0px 3rem">
                  <div class="block">
                    <span class="demonstration">焦距：</span>
                    <el-slider
                      class="zj_slider"
                      v-model="valueJj"
                      :show-tooltip="false"
                      @change="changeTopSlider"
                    ></el-slider>
                  </div>
                  <div class="block">
                    <span class="demonstration">光圈：</span>
                    <el-slider
                      class="zj_slider"
                      v-model="valueCircle"
                      :show-tooltip="false"
                      @input="changeSlider"
                    ></el-slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MyApis from "../../../apis";
import HikCameraVideo from "../../../../../../components/src/HikCameraVideo.vue";
export default {
  name: "HikPlayVideo",
  controller: "UI",
  action: "HikPlayVideo",
  components: {
    HikCameraVideo,
  },
  data() {
    return {
      isStart: false,
      valueJj: 50, //记录old值，如果当前值大于old值放大，当前值小于old值缩小
      valueCircle: 50,
      oldValueJj: 50, //记录old值，如果当前值大于old值放大，当前值小于old值缩小
      oldCircle: 50,
      showFenqi: false,
      filterText: "",
      loading: false,
      loadingText: "",
      record: null,
      timeInte: null,
      nodes: [],
      autoplay: true,
      defaultProps: {
        children: "children",
        label: "label",
      },
      previewPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: false,
      },
      playbackPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: false,
      },
      cameras: [
        {
          cameraId: "",
          cameraName: "",
          backUrl: "",
          showClose: false,
        },
      ],
      selectPlayerIndex: 0,
      color: ["2ac1ff", "2ac1ff", "#2ac1ff", "2ac1ff", "2ac1ff", "2ac1ff"],
      mc: "",
      Triangle: "",
      showtype: "1", //摆放几个视频
      showtypeIndex: 0,
      isShowAll: false,
      treeClickCount: 0,
     
    };
  },
  //  computed: {
  //   ...mapGetters([
  //       'isShowbgImg'
  //     ])
  // },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.search();
  },
  mounted() {
    this.$store.dispatch("submitIsShowbg", false);
    // this.handleLoad();
    this.logInfo.ActionName = "实时监控查询";
    this.logInfo.LogMessage = "实时监控查询";
    this.logInfo.ModuleName = "视频监控";
    this.logInfo.PageName = "实时监控页面";
    this.addOperationLog();
    // this.theme.header.visiable = false
    // this.theme.sidemenu.visiable = false
  },
  methods: {
    ...mapActions(["submitIsShowbg"]),
    dbOneVideo() {
      if (this.showtype == 1) {
        // 全屏
        this.$refs.childOneVideo.onDblClick();
      } else {
        this.changeQPing();
      }
    },
    changeQPing() {
      this.isShowAll = !this.isShowAll;
      if (this.isShowAll) {
        this.theme.header.visiable = false;
        this.theme.sidemenu.visiable = false;
      } else {
        this.theme.header.visiable = true;
        this.theme.sidemenu.visiable = true;
      }
    },
    closeNowVideo(index) {
      this.cameras[index].cameraId = "";
      this.cameras[index].cameraName = "";
      this.cameras[index].backUrl = "";
      // console.log(index)
      // console.log(this.cameras)
      //  if(this.selectPlayerIndex>index){
      this.selectPlayerIndex = index;
      //  }
    },
    searchEnterFun() {},
    startOneVideo() {
      // 开始播放视频
    },
    play() {
      this.isStart = true;
    },
    stop() {
      this.isStart = false;
    },
    stopOneVideo() {
      // 停止播放视频
      this.$refs.childOneVideo.stop();
    },
    //获取区域
    search() {
      let that = this;
      new MyApis.EquipmentApi()
        .GetRegionEquipment({
          EquipmentType: "Monitor",
        })
        .then((r) => {
          r = r.data.Data;
          // console.log(r);
          this.nodes = that.convertToTreeNodesfunction(r);
          // console.log("this.nodes");
          // console.log(this.nodes);
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    convertToTreeNodesfunction(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        var region = {
          id: regionData.RegionId,
          label: regionData.RegionName,
          children: [],
        };

        if (!regionData.Devices) continue;
        for (let j = 0; j < regionData.Devices.length; j++) {
          var deviceData = regionData.Devices[j];
          region.children.push({
            id: deviceData.DeviceId,
            label: deviceData.DeviceName,
            children: [],
          });
        }
        result.push(region);
      }
      // console.log("result")
      // console.log(result)
      return result;
    },
    nodeoneClick(data, node) {
      if (node.level == 2) {
        if (this.cameras && this.cameras[0]) {
          this.cameras[0].cameraId = data.id;
          this.cameras[0].cameraName = data.label;
          this.cameras[0].backUrl = "";
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    nodeClick: function (data, node, self) {
      //记录点击次数
      this.treeClickCount++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCount >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount == 1) {
          //把次数归零
          this.treeClickCount = 0;
          //单击事件处理
        } else if (this.treeClickCount > 1) {
          //把次数归零
          this.treeClickCount = 0;
          let showtype = Number(this.showtype);
          if (node.level == 2) {
            if (this.cameras && this.cameras[this.selectPlayerIndex]) {
              this.cameras[this.selectPlayerIndex].cameraId = data.id;
              this.cameras[this.selectPlayerIndex].cameraName = data.label;
              this.cameras[this.selectPlayerIndex].backUrl = "";

              this.selectPlayerIndex = (this.selectPlayerIndex + 1) % showtype;
            }
          }
        }
      }, 300);
    },
  },
  beforeDestroy() {
    this.theme.sidemenu.visiable = true;
    this.$store.dispatch("submitIsShowbg", true);
  },
};
</script>
<style lang="scss" scoped>
</style>